import classNames from 'classnames'

import type { ReactElement } from 'react'

import AppStoreLogo from '~/assets/app-store-logo.png'
import GooglePlayStoreLogo from '~/assets/google-play-store-logo.png'
import DefaultImage from '~/assets/image-default.png'
import WebLogo from '~/assets/web-logo.png'

import './styles.scss'

export interface Props {
  appLogoUrl?: string | null
  appName?: string
  appPlatform?: string
  appUrl?: string
  borderColor?: string
  className?: string
  darkBackground?: boolean
  size: SIZES
}

export const PlatformIcon = ({
  appPlatform,
  darkBackground = false,
  size,
}: Pick<Props, 'appPlatform' | 'darkBackground' | 'size'>): ReactElement | null => {
  const googleStoreLogoClasses = classNames('google-store-logo', size)
  const appleStoreLogoClasses = classNames('app-store-logo', size)
  const webLogoClasses = classNames('web-logo', size, { 'web-logo--dark-background': darkBackground })

  return appPlatform === 'android' ? (
    <div className="google-store-logo-container">
      <img alt="google-store-logo" className={googleStoreLogoClasses} src={GooglePlayStoreLogo} />
    </div>
  ) : appPlatform === 'ios' ? (
    <img alt="app-store-logo" className={appleStoreLogoClasses} src={AppStoreLogo} />
  ) : appPlatform === 'web' ? (
    <img alt="web-logo" className={webLogoClasses} src={WebLogo} />
  ) : null
}

const AppLogoIcon = ({ appLogoUrl, appUrl }: Pick<Props, 'appLogoUrl' | 'appUrl'>): ReactElement => {
  if (appUrl) {
    return (
      <a className="app-logo-link-container" href={appUrl} rel="noreferrer" target="_blank">
        <img alt="app logo" className="app-logo" src={appLogoUrl || DefaultImage} />
      </a>
    )
  }

  return <img alt="app logo" className="app-logo" src={appLogoUrl || DefaultImage} />
}

const AppLogo = ({
  appLogoUrl,
  appName,
  appPlatform,
  appUrl,
  borderColor,
  className,
  darkBackground,
  size,
}: Props): ReactElement => {
  return (
    <div className="app-logo-component">
      <div className={classNames('icon-container', className, size)}>
        <AppLogoIcon appLogoUrl={appLogoUrl} appUrl={appUrl} />
        {appPlatform ? (
          <a href={appUrl} rel="noreferrer" target="_blank">
            <div
              className={classNames('platform-container', size)}
              style={borderColor ? { backgroundColor: borderColor } : {}}
            >
              <PlatformIcon appPlatform={appPlatform} darkBackground={darkBackground} size={size} />
            </div>
          </a>
        ) : null}
      </div>
      {appName && <span className="application-name">{appName}</span>}
    </div>
  )
}

export default AppLogo
